export default "__VITE_ASSET__YR9NZqsL__"